<template>
    <!-- * 新建收藏夹 -->
    <favorites-input ref="favorites" @back="favorite?.open()" @confirm="methods.add" />
    <!-- * 选择收藏夹 -->
    <favorite-input ref="favorite" @new="favorites?.open()" @confirm="methods.select" />

    <div @click="methods.collect">
        <slot :collected="collected">
            <!-- * 常规样式 -->
            <div
                class="inline-flex items-center justify-center rounded-[4px] cursor-pointer t-border-main hover:bg-main hover:text-white"
                :class="[collected ? 'bg-main text-white' : 'bg-white text-main', size == 'small' ? 'h-[40px] px-[20px]' : 'h-[48px] px-[24px]']">
                <ui-icon name="star" class="mr-[4px]" />{{ collected ? $t("Added") : $t("Favorite") }}
            </div>
        </slot>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon } from "various-ui";
//* 私有组件
import { FavoritesInput, FavoriteInput } from "./components";
//* 组件属性
import { useComposable } from "./src/composable";

//* 组件属性注册
defineProps({
    size: { type: String as PropType<"small">, default: "" },
});

//* 组合函数
const { refs, nodes, methods } = useComposable();
const { favorites, favorite } = nodes;
const { collected } = refs;

//* 组件初始化
await methods.init();
</script>
